import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { css } from "styled-components";

quickOrderPageContainerStyles.container = {
    css: css`
        & div[class^="GridOffset"] {
            width: 100% !important;
            margin: 0 !important;
        }
    `,
};

productSelectorStyles.container = {
    css: css`
        background: #f6f8f8;
        padding: 20px;
    `,
};

productSelectorStyles.searchGridItem = {
    css: css`
        & div[class^="FormFieldStyle"] {
            display: flex;
            flex-direction: row;
            align-items: center;
            label {
                flex-basis: 75px;
            }
            div[class^="FormInputWrapper"] {
                margin-top: 0 !important;
            }
            span[data-test-selector="productSelector_search-selectedText"] {
                padding: 9px 30px 9px 11px;
                text-overflow: ellipsis;
            }
        }
    `,
    width: [12, 12, 5, 5, 5],
};

productSelectorStyles.qtyGridItem = {
    css: css`
        & div[class^="FormFieldStyle"] {
            display: flex;
            flex-direction: row;
            align-items: center;
            label {
                flex-basis: 45px;
            }
            div[class^="FormInputWrapper"] {
                flex-basis: 40%;
                margin-top: 0 !important;
            }
        }
    `,
    width: [6, 6, 3, 2, 2],
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [0, 0, 0, 2, 2],
    css: css`
        visibility: hidden;
    `,
};

productSelectorStyles.buttonGridItem = {
    width: [12, 12, 4, 3, 3],
    css: css`
        justify-content: flex-end;
        button {
            margin-top: 0 !important;
        }
    `,
};

productSelectorStyles.selectButton = {
    variant: "primary",
};